import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

export default function Index() {
  return (
    <div className="flex justify-center items-center h-9 w-9">
      <ProgressSpinner />
    </div>
  );
}
